<script>
import { Bar, mixins } from "vue-chartjs";
export default {
  mixins: [mixins.reactiveData],
  name: "Bar",
  // props: ["chartdata"],

  props: {
    customerReportType: {
      required: true
    },
    customerYear: {
      required: true
    },
    customerMonth: {
      required: true
    }
  },
  data() {
    return {
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  extends: Bar,

  created() {
    this.getChartDataYear();
  },

  watch: {
    customerReportType: {
      handler(val) {
        if (val === "Year" && this.customerYear) {
          this.getChartDataYear();
        } else if (val === "Month" && this.customerMonth) {
          this.getChartDataMonth();
        }
      }
    },
    customerYear: {
      handler() {
        this.getChartDataYear();
      }
    },
    customerMonth: {
      handler() {
        this.getChartDataMonth();
      }
    }
  },

  methods: {
    getChartDataMonth() {
      this.$apollo
        .watchQuery({
          query: require("../api/getCustomersByDay.graphql"),
          variables: {
            month: this.customerMonth,
            year: this.customerYear
          }
        })
        .refetch({
          variables: {
            month: this.customerMonth,
            year: this.customerYear
          }
        })
        .then(data => {
          let customers = data.data.getCustomersByDay;
          let graphLabels = new Array();
          let graphCount = new Array();
          customers.forEach(element => {
            graphLabels.push(element.date);
            graphCount.push(element.count);
          });

          let chartData = {
            labels: graphLabels,
            datasets: [
              {
                label: "Customers",
                backgroundColor: "#000000",
                data: graphCount
              }
            ]
          };
          this.chartData = chartData;
        });
    },
    getChartDataYear() {
      this.$apollo
        .watchQuery({
          query: require("../api/getCustomersByMonth.graphql"),
          variables: {
            year: this.customerYear
          }
        })
        .refetch({})
        .then(data => {
          let customers = data.data.getCustomersByMonth;
          let graphLabels = new Array();
          let graphCount = new Array();
          customers.forEach(element => {
            graphLabels.push(element.month);
            graphCount.push(element.count);
          });

          let chartData = {
            labels: graphLabels,
            datasets: [
              {
                label: "Customers",
                backgroundColor: "#000000",
                data: graphCount
              }
            ]
          };
          this.chartData = chartData;
        });
    }
  }
};
</script>
